import { fetcher } from '@commenda/utils';
import { LegacyDocumentType } from '@prisma/client';

import { IApiResponse } from './types';

export interface ILinkDocumentTypeParams {
  corporationId: number;
  fileId: number;
  documentType: LegacyDocumentType;
}

export async function linkDocumentType({
  corporationId,
  fileId,
  documentType,
}: ILinkDocumentTypeParams): Promise<IApiResponse<null>> {
  const response = await fetcher('drive-view/file/link-document-type', {
    method: 'POST',
    body: { corporationId, fileId, documentType },
  });

  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    return {
      success: false,
      error: body?.message || 'Failed to file the document',
      statusCode: response.status,
      data: null,
    };
  }

  return {
    success: true,
    error: null,
    statusCode: response.status,
    data: null,
  };
}
